import React from 'react'
import 'whatwg-fetch'
import moment from "moment"
import Calendar from 'react-calendar'
import './Calendar.css';

import {
  useToast,
  //useColorMode,
  useDisclosure,
  SimpleGrid,
  Flex,
  Box,
  Button,
  IconButton,
  Input,
  Select,
  Text,
  //Image,
  Divider,
  Textarea,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Stack,
  Icon,
  Heading,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/core'

//import { Sticky, StickyProvider } from 'react-stickup';

/**
 * TODO:
 * - Set end -> automatically find start and set end for that
 * - Fetch bookings after a while?
 * - Prices
 */

export default function MainComponent() {
  moment.locale('de'); //try setting locale gloablly, doesn't work
  const self = this;
  const [bookings, setBookings] = React.useState([]);
  const [assigned, setAssigned] = React.useState([]);
  const [appointments, setAppointments] = React.useState([]);
  const [toastMessage, setToastMessage] = React.useState();
  const defaultAlert = {type: "info", title: "Keine Termine gewählt", body: "Wählen Sie einen Tag im Kalender an und fügen Sie ihn als Terminvorschlag zur Anfrage hinzu!"};
  const [alertMessage, setAlertMessage] = React.useState(defaultAlert);
  const [calendarSelected, setCalendarSelected] = React.useState();
  const [selected, setSelected] = React.useState();
  const [selectedAction, setSelectedAction] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const formatter = new Intl.DateTimeFormat('de', {weekday: 'short', day: '2-digit', month: 'short', year: '2-digit'});
  const toast = useToast();


  const [requestType, setRequestType] = React.useState("Aufnahme Solo");
  const [customerName, setCustomerName] = React.useState("");
  const [customerMessage, setCustomerMessage] = React.useState("");
  const [customerEmail, setCustomerEmail] = React.useState("");
  const [customerPhone, setCustomerPhone] = React.useState("");

  //const bookingCalendar = React.createRef();

  //const { colorMode, toggleColorMode } = useColorMode();

  //console.log(localStorage.getItem("iosPwaPrompt"));

  // first load
  React.useEffect(() => {
    // load user info from localStorage
    const userData = localStorage.getItem("MegalithWebAppUser");
    if (userData) {
      const user = JSON.parse(userData);
      setCustomerName(user.name);
      setCustomerEmail(user.email);
      setCustomerPhone(user.phone);
    }
    // get booked days from server
    loadBooked();
  }, [])

  // update assigned days when appointments change
  React.useEffect(() => {
    const arr = [];
    appointments.forEach(appt => {
      arr.push(appt.startDate.toDate());
      if (appt.endDate) {
        const nuDate = appt.startDate.clone();
        while (nuDate.isBefore(appt.endDate)) {
          nuDate.add(1, "day");
          arr.push(nuDate.toDate());
        }
      }
    });
    setAssigned(arr);
  }, [appointments])

  // show toast when toast message changes
  React.useEffect(() => {
    if (toastMessage) {
      var {title, body, type} = toastMessage;
      if (!type) {
        type = "error";
      }
      toast({
        title,
        description: body,
        status: type,
        duration: 6000,
        position: "bottom",
        isClosable: true
      });
    }
  }, [toastMessage, toast]);

  // loads booked days from server and populates bookings
  const loadBooked = function () {
    setLoading(true);
    fetch('/bookings')
      .then(function (response) {
        return response.json()
      }).then(function (json) {
        const bookArray = [];
        json.forEach(bl => {
          bookArray.push(new Date(bl[0], bl[1], bl[2]));
        });
        setBookings(bookArray);
        console.log('Read iCal calendars')
        if (appointments.length === 0) {
          setAlertMessage(defaultAlert);
        }
      }).catch(function (ex) {
        setAlertMessage({type: "error", title: "Serverfehler", body: "Die belegten Termine können nicht geladen werden, versuchen sie es später noch einmal"});
        console.log('parsing failed', ex)
      }).finally(function () {
        setLoading(false);
      });
  }

  //called when a day is selected in the calendar
  const dayClick = function (date) {
    const data = {
      date: moment(date),
      isBookedDay: bookings.find(elem => sameDay(elem, date)) !== undefined,
      isAssignedDay: assigned.find(elem => sameDay(elem, date)) !== undefined,
    }
    if (selectedAction === 1) {
      setDay(null, data);
      setSelectedAction(0);
    } else if (selectedAction === 2) {
      setEnd(null, data);
      setSelectedAction(0);
    } else {
      setCalendarSelected(date);
      setSelected(data);
    }
  }

  // sets start day, called on add appointment button or directly by calendar click
  const setDay = function (event, par) {
    var myInfo = par ? par : selected;
    if (!myInfo) {
      setToastMessage({type: "info", title: "Tag wählen", body: "Bitte wählen Sie einen Tag aus"})
      setSelectedAction(1);
    }
    else if (myInfo.date.isBefore(moment())) {
      setToastMessage({type: "error", title: "Vergangenheit", body: "Der Termin kann nicht in der Vergangeheit stattfinden"})
    }
    else if (myInfo.isBookedDay) {
      setToastMessage({type: "error", title: "Tag Belegt", body: "Der Termin ist leider schon belegt"})
    }
    else if (myInfo.isAssignedDay) {
      setToastMessage({type: "warning", title: "Schon ausgewählt", body: "Der Termin ist schon in der Liste"})
    } else {
      myInfo.isAssignedDay = true;
      setAppointments(appointments.concat([{
        startDate: myInfo.date.clone(),
        start: formatter.format(myInfo.date)
      }]))
      setCalendarSelected([]);
      setSelected();
    }
  }

  // sets end day, called on set end button or directly by calendar click
  const setEnd = function (event, par) {
    const myInfo = par ? par : selected;
    // TODO: find appointment with start just before date
    const index = appointments.length - 1;
    if (!myInfo) { // no date passed
      if (appointments.length === 0) {
        setToastMessage({type: "error", title: "Kein Termin", body: "Bitte fügen Sie einen Termin hinzu"})
      } else { // prepare next click selection
        setToastMessage({type: "info", title: "Tag wählen", body: "Bitte wählen Sie einen Tag aus"})
        setSelectedAction(2);
      }
    }
    else if (myInfo.date.isBefore(moment())) {
      setToastMessage({type: "error", title: "Zu früh", body: "Bitte wählen sie einen späteren Termin"})
    }
    else if (myInfo.isBookedDay) {
      setToastMessage({type: "error", title: "Tag Belegt", body: "Der Termin ist leider schon belegt"})
    }
    else if (appointments.length > 0) {
      if (myInfo.date.isSame(appointments[index].startDate)) {
        if (appointments[index].endDate) { // erase end date if exists
          delete appointments[index].endDate;
          delete appointments[index].end;
          appointments[index].isWarning = false;
          setAppointments(appointments.concat([]));
          setCalendarSelected([]);
          setSelected();
        } else {
          setToastMessage({type: "info", title: "Gleicher Tag", body: "Termine über einen Tag brauchen kein Ende"})
        }
      } else if (myInfo.date.isBefore(appointments[index].startDate)) {
        setToastMessage({type: "error", title: "Ende vor Termin", body: "Das Ende des Termins kann nicht vor dem Termin sein"})
      } else {
        // check in between days
        const nuDate = appointments[index].startDate.clone();
        appointments[index].isWarning = false;
        while (nuDate.isBefore(myInfo.date)) {
          nuDate.add(1, "day");
          if (bookings.find(elem => sameDay(elem, nuDate.toDate())) !== undefined) {
            //setToastMessage({type:"warning", title:"Warnung", body:"In diesem Terminvorschlag befinden sich geblockte Tage, er wird trotzdem hinzugefügt"})
            appointments[index].isWarning = true;
          }
        }

        myInfo.isAssignedDay = true;
        appointments[index].endDate = myInfo.date.clone();
        appointments[index].end = formatter.format(myInfo.date);
        setAppointments(appointments.concat([]));
        setCalendarSelected([]);
        setSelected();
      }
    } else {
      setToastMessage({type: "error", title: "Kein Termin", body: "Bitte fügen Sie einen Termin hinzu"})
    }
  }

  // deletes the appointment at idx
  const deleteAppointment = function (idx) {
    //appointments.splice(idx,1);
    //React.setState({appointments})
    const newAppointments = appointments.filter((item, idex) => idex !== idx);
    setAppointments(newAppointments);
    if (newAppointments.length === 0) {
      setAlertMessage(defaultAlert);
    }
  }

  // update states based on input changes
  const handleInputChange = function (event) {
    const target = event.target;
    const name = target.name;
    switch (name) {
      case "name": setCustomerName(target.value);
        break;
      case "message": setCustomerMessage(target.value);
        break;
      case "email": setCustomerEmail(target.value);
        break;
      case "phone": setCustomerPhone(target.value);
        break;
      case "type": setRequestType(target.value);
        break;
      default:
        break;
    }
  }

  // send button pressed -> check and send
  const handleSubmit = function (event) {
    const user = {};
    user.name = customerName;
    user.email = customerEmail;
    user.phone = customerPhone;
    localStorage.setItem("MegalithWebAppUser", JSON.stringify(user));

    if (!customerName) {
      setToastMessage({type: "error", title: "Bitte Namen angeben", body: "Bitte geben Sie Ihren Namen an"})
    } else if (!customerEmail && !customerPhone) {
      setToastMessage({type: "error", title: "Bitte Kontakt angeben", body: "Bitte geben sie eine Kontaktmöglichkeit an"})
    } else if (!customerMessage && appointments.length === 0) {
      setToastMessage({type: "error", title: "Kein Inhalt", body: "Bitte geben sie einen Terminvorschlag oder eine Nachricht an"})
    } else {
      const dates = [];
      appointments.forEach(appointment => {
        const s = appointment.startDate;
        const e = appointment.endDate;
        const appt = {
          startDate: [s.year(), s.month(), s.date()]
        };
        if (e) {
          appt.endDate = [e.year(), e.month(), e.date()]
        }
        dates.push(appt);
      });
      console.log(dates);
      fetch('/message', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: customerName,
          message: customerMessage,
          email: customerEmail,
          phone: customerPhone,
          type: requestType,
          dates: dates
        })
      }).then(result => {
        if (!result.ok) {
          setToastMessage({type: "error", title: "Fehler", body: "Ein Serverfehler ist beim senden aufgetreten, versuchen Sie es später noch einmal"});
        } else {
          result.json().then(jsonData=>{
            if(jsonData.status != "OK"){
              setToastMessage({type: "error", title: "Fehler", body: "Ein Serverfehler ist beim senden aufgetreten, versuchen Sie es später noch einmal"});
            } else{
              setToastMessage({type: "success", title: "Anfrage gesendet", body: "Wir melden uns baldestmöglich bei Ihnen"});
              setAlertMessage({type: "success", title: "Wir bearbeiten Ihre Anfrage", body: "Wir hoffen Sie bald bei uns begrüßen zu dürfen"});
              resetInput();
            }
          }, reason=>{
              setToastMessage({type: "error", title: "Fehler", body: "Ein Serverfehler ist beim senden aufgetreten, versuchen Sie es später noch einmal (json)"});
          })
        }
      }).catch(function (ex) {
        setToastMessage({type: "error", title: "Fehler", body: "Ein Fehler ist beim senden aufgetreten, sind Sie mit dem Internet verbunden?"});
      })
    }
    // only needed for onSubmit from forms to prevent redirection
    //event.preventDefault();
  }

  // reset appointments and message field
  const resetInput = function () {
    setCustomerMessage("");
    setAppointments([]);
  }

  // gets the class name for a day box (set background based on bookings)
  const dayClassName = function (data) {
    if (data.view !== 'month') return "";
    return assigned.find(elem => sameDay(elem, data.date)) === undefined ? "" : "assigned-day";
  }

  // check if JS Date is booked
  const isBookedDay = function (data) {
    if (data.view !== 'month') return false;
    return bookings.find(elem => sameDay(elem, data.date)) !== undefined;
  }

  // label for the navigation in the calendar, shows loading state with spinner
  const navLoadingLabel = function ({date, label, locale, view}) {
    return loading ? <Spinner /> : label;
  }

  const infoDisclosure = useDisclosure();
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center" >
      <Flex
        flexDirection="column"
        alignItems="stretch"
        justifyContent="center"
        shadow="sm"
        maxWidth={500}
        //backgroundColor="#fff"
        m="2px"
        p="5px"
      >
        <Box mb="3px" borderRadius="1px" display="flex" justifyContent="center" alignItems="center">
          <Icon onClick={infoDisclosure.onOpen} name="megalithlogo" width="70%" height="100%" />
        </Box>
        <Box>
          <Text fontSize="2xl" fontWeight="bold" textAlign="center">
            Online Booking
          </Text>
        </Box>
        <Divider borderColor="blackAlpha.500" />
        <Box>
          <Calendar
            navigationLabel={navLoadingLabel}
            minDate={new Date()}
            value={calendarSelected}
            onChange={dayClick}
            tileDisabled={isBookedDay}
            tileClassName={dayClassName}
          />
        </Box>
        <SimpleGrid columns={2} spacingX={1} spacingY={1}>
          <Button leftIcon="add" onClick={setDay}>Neuer Termin</Button>
          <Button leftIcon="calendar" onClick={setEnd}>Ende Setzen</Button>
        </SimpleGrid>
        <Divider borderColor="blackAlpha.500" />
        <Stack>
          {appointments.length === 0 ?
            <Alert status={alertMessage.type} display="flex" justifyContent="center" flexDirection="column">
              <AlertIcon width="30px" height="30px" mb="2" />
              <AlertTitle mr={1} mb={1}>{alertMessage.title}</AlertTitle>
              <AlertDescription textAlign="center">
                {alertMessage.body}
              </AlertDescription>
            </Alert>
            :
            <Heading textAlign="center" size="md">
              Terminvorschläge
        </Heading>
          }
          {appointments.map((appointment, idx) =>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              key={idx}
            >
              {appointment.isWarning ?
                <Popover>
                  <PopoverTrigger>
                    <Icon name="warning-2" color="yellow.500" />
                  </PopoverTrigger>
                  <PopoverContent zIndex={4}>
                    <PopoverCloseButton />
                    <PopoverHeader fontWeight="bold">Geblockte Tage</PopoverHeader>
                    <PopoverBody>Dieser Zeitraum enthält geblockte Tage und kann eventuell nicht vollständig genutzt werden.</PopoverBody>
                  </PopoverContent>
                </Popover>
                :
                <Icon name="check-circle" color="green.500" />
              }
              <Text>{appointment.start} {appointment.end ? ' - ' + appointment.end : ""}</Text>
              <IconButton aria-label="icon" icon="delete" color="red.500" onClick={deleteAppointment.bind(self, idx)} />
            </Box>
          )}
        </Stack>
        <Divider borderColor="blackAlpha.500" />
        <SimpleGrid columns={2} spacingX={1} spacingY={1}>
          <Text display="flex" alignItems="center">
            Anfrage für:
          </Text>
          <Select name="type" selected={requestType} onChange={handleInputChange} icon="chevron-down">
            <option value="Aufnahme Solo">Aufnahme Solo</option>
            <option value="Aufnahme Band">Aufnahme Band</option>
            <option value="Mix/Master">Mix/Master</option>
            <option value="Andere">Andere</option>
          </Select>
          <Text display="flex" alignItems="center">
            Ihr Name:
          </Text>
          <Input name="name" value={customerName} onChange={handleInputChange} placeholder="Max Mustermann" />
          <Text>Ihre Nachricht:</Text>
          <Textarea name="message" value={customerMessage} onChange={handleInputChange} placeholder="Ich möchte die Megalith Studios buchen." />
          <Text display="flex" alignItems="center">
            eMail:
          </Text>
          <Input name="email" value={customerEmail} onChange={handleInputChange} placeholder="max.mustermann@email.de" />
          <Text display="flex" alignItems="center">
            Telefonnummer:
          </Text>
          <Input name="phone" value={customerPhone} onChange={handleInputChange} placeholder="+49 160 1234567" />
        </SimpleGrid>
        <Divider borderColor="blackAlpha.500" />
        <Button onClick={handleSubmit} leftIcon="email">Anfrage Senden</Button>
        <Text fontSize="xs" textAlign="center">
          Alle eingegebenen Daten werden ausschliesslich dazu verwendet Ihre
          Anfrage zu beantworten
        </Text>
        <Modal isOpen={infoDisclosure.isOpen} onClose={infoDisclosure.onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Megalith Studios Booking</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>WebApp © 2020 by Normen Hansen</Text>
            </ModalBody>
            <ModalFooter>
              <Button size="xs" mr={2} onClick={loadBooked}>
                Kalender Neu Laden
              </Button>
              <Button size="xs" mr={2} onClick={resetInput}>
                Eingaben Löschen
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Flex>
    </Flex>
  );
}

function sameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();
}
